import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface City {
  id?: string
  name: string
  code: string
  countryId: string
  stateId: string
}

export function getCustomProps(data: any): any {
  const customFields = new Map<string, any>([])
  Object.keys(data).forEach(key => {
    if (key.startsWith('custom:')) {
      const nData: any = data
      customFields.set(key, nData[key])
    }
  })
  return Object.fromEntries(customFields)
}

export async function getCities(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  let where = []
  if (search) {
    where.push(
      `CONCAT(countries.name, states.name, cities.name, cities.code) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN cities.code ~ '^[0-9]+$' THEN CAST(cities.code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, cities.code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN cities.code ~ '^[0-9]+$' THEN CAST(cities.code AS NUMERIC) ELSE NULL END), cities.code"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_cities'],
    fields: [
      'cities.id',
      'cities.code',
      'cities.name',
      'countries.name as country',
      'states.name as province',
      'cities.updated_at'
    ],
    join: [
      'INNER JOIN states ON cities.state_id = states.id',
      'INNER JOIN countries ON states.country_id = countries.id'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response
}

export async function getCityModel(id: string): Promise<City> {
  const data = await getData<any>({
    tables: ['pg_cities'],
    fields: [
      'id',
      'name',
      'code',
      'country_id as countryId',
      'state_id as stateId',
      'custom_fields as custom'
    ],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createCity(data: City): Promise<boolean> {
  const response: any = await http.post('country/cities', {
    countryId: data.countryId,
    stateId: data.stateId,
    name: data.name,
    code: data.code,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateCity(data: City, id: string): Promise<boolean> {
  const response: any = await http.put('country/cities/' + id, {
    countryId: data.countryId,
    stateId: data.stateId,
    name: data.name,
    code: data.code,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteCity(id: string): Promise<boolean> {
  const response: any = await http.delete('country/cities/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
